<template>
  <!-- prettier-ignore -->
  <label :class="classes">
    <input
      class="checkbox__input"
      type="checkbox"
      :checked="value"
      :name="name"
      :value="value"
      @click="emitUpdate"
    />

    <ovp-icon
      class="checkbox__icon"
      :art="icon.art"
      :name="icon.name"
    />

    <div
      class="checkbox__label"
      v-html="title"
    />
  </label>
</template>

<script>
export default {
  name: 'OvpCheckbox',

  model: {
    prop: 'value',
    event: 'update',
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    theme: {
      type: String,
      default: 'light',
    },

    name: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      default: '',
    },

    validate: {
      type: Object,
      default: () => {},
    },

    value: {
      type: Boolean,
    },
  },

  computed: {
    classes() {
      return {
        checkbox: true,
        'checkbox--disabled': this.disabled,
        'checkbox--selected': this.value,
        [`checkbox--${this.theme}`]: true,
      }
    },

    icon() {
      const name = this.value ? 'square-check' : 'square'

      switch (this.theme) {
        case 'dark':
          return {
            art: 'solid',
            name,
          }
        case 'light':
        default:
          return {
            art: 'light',
            name,
          }
      }
    },
  },

  methods: {
    emitUpdate() {
      this.validate?.$touch()

      this.$emit('update', !this.value)
    },
  },
}
</script>

<style name="mobile" scoped>
.checkbox {
  cursor: pointer;
  display: inline-block;
  position: relative;
  font-size: 15px;
  line-height: 20px;
  color: var(--c-black);
  height: 20px;

  .checkbox__icon {
    position: absolute;
    font-size: 20px;
    color: var(--c-black);
  }

  .checkbox__input {
    pointer-events: none;
    position: absolute;
    opacity: 0;

    &:focus ~ .checkbox__label {
      color: var(--c-original-green);
    }
  }

  .checkbox__label {
    padding-left: 30px;
    user-select: none;
    line-height: 21px;
  }

  &:hover .icon,
  &--selected.checkbox--selected .icon {
    color: var(--c-original-green);
  }

  &--dark {
    .checkbox {
      .checkbox__icon {
        color: var(--c-white);
      }
    }
  }

  &--disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>